import { useCallback, useContext, useState } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-component-ts';
import { UserType } from '@kanda-libs/ks-frontend-services';

import { USERS_MODAL_ID } from './constants';

export interface UsersHook {
  onClick: (user: UserType) => void;
  user: UserType | undefined;
}

export default function useUsers(): UsersHook {
  const [user, setUser] = useState<UserType | undefined>(undefined);
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback((selected: UserType) => {
    setUser(selected);
    showModal(USERS_MODAL_ID);
  }, []);

  return {
    onClick,
    user,
  };
}
